/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';

import {ClrResponsiveNavCodes} from './clrResponsiveNavCodes';
import {ClrResponsiveNavigationService} from './clrResponsiveNavigationService';
export class NavLevelDirective implements OnInit {
     _level: number;
/**
 * @param {?} responsiveNavService
 * @param {?} elementRef
 */
constructor(private responsiveNavService: ClrResponsiveNavigationService,
private elementRef: ElementRef) {}
/**
 * @return {?}
 */
ngOnInit() {
        if (this.level !== ClrResponsiveNavCodes.NAV_LEVEL_1 && this.level !== ClrResponsiveNavCodes.NAV_LEVEL_2) {
            console.error("Nav Level can only be 1 or 2");
            return;
        }
        this.responsiveNavService.registerNav(this.level);
        this.addNavClass(this.level);
    }
/**
 * @param {?} level
 * @return {?}
 */
addNavClass(level: number) {
        const /** @type {?} */ navHostClassList = this.elementRef.nativeElement.classList;
        if (level === ClrResponsiveNavCodes.NAV_LEVEL_1) {
            navHostClassList.add(ClrResponsiveNavCodes.NAV_CLASS_LEVEL_1);
        } else if (level === ClrResponsiveNavCodes.NAV_LEVEL_2) {
            navHostClassList.add(ClrResponsiveNavCodes.NAV_CLASS_LEVEL_2);
        }
    }
/**
 * @return {?}
 */
get level(): number {
        return this._level;
    }
/**
 * @return {?}
 */
get responsiveNavCodes(): ClrResponsiveNavCodes {
        return ClrResponsiveNavCodes;
    }
/**
 * @return {?}
 */
open(): void {
        this.responsiveNavService.sendControlMessage(ClrResponsiveNavCodes.NAV_OPEN, this.level);
    }
/**
 * @return {?}
 */
close(): void {
        this.responsiveNavService.sendControlMessage(ClrResponsiveNavCodes.NAV_CLOSE, this.level);
    }
/**
 * @param {?} target
 * @return {?}
 */
onMouseClick(target: any) {
        let /** @type {?} */ current: any = target;  // Get the element in the DOM on which the mouse was clicked
        const /** @type {?} */ navHost: any = this.elementRef.nativeElement;  // Get the current nav native HTML element

        // Start checking if current and navHost are equal.
        // If not traverse to the parentNode and check again.
        while (current) {
            if (current === navHost) {
                return;
            } else if (current.classList.contains("nav-link")) {
                this.close();
                return;
            }
            current = current.parentNode;
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.responsiveNavService.unregisterNav(this.level);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clr-nav-level]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ClrResponsiveNavigationService, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_level': [{ type: Input, args: ["clr-nav-level", ] },],
'onMouseClick': [{ type: HostListener, args: ["click", ["$event.target"], ] },],
};
}

function NavLevelDirective_tsickle_Closure_declarations() {
/** @type {?} */
NavLevelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NavLevelDirective.ctorParameters;
/** @type {?} */
NavLevelDirective.propDecorators;
/** @type {?} */
NavLevelDirective.prototype._level;
/** @type {?} */
NavLevelDirective.prototype.responsiveNavService;
/** @type {?} */
NavLevelDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
